import {
  type Country as MelwaysCountry,
  getClassificationFromSiteName,
  type SiteName,
} from '@seek/melways-sites';

import type { Country } from '@seek/chalice-types';

const mapToProperCountry = (country?: MelwaysCountry | null): Country =>
  country?.toUpperCase() as Country;

export const getCountryFromSite = (site: SiteName): Country =>
  mapToProperCountry(
    getClassificationFromSiteName(mapToMelwaysSiteName(site))?.country,
  );

// Due to sku config providing "site" as a string ..
// .. we need to map it to the Melways SiteName type
export const mapToMelwaysSiteName = (site: string): SiteName =>
  site as SiteName;
